import React, { useState } from 'react';
import PropTypes from 'prop-types'
import { Button, Form,Container, Spinner } from 'react-bootstrap';
import MaskedFormControl from 'react-bootstrap-maskedinput'
import { useNavigate , useParams} from 'react-router-dom';
import './../CSS/form.css';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from 'moment'

import axios from 'axios';
import Notification from './../../Components/assets/Modals/notification'
import {REGISTER_ALUMNI} from './../../url/index'
import NotifyError from './../../Components/assets/Modals/errorModal'

function OldStudent() {

    // const navigate = useNavigate();
    // const navigateToHome = () => {
    //  navigate('/');
    // }

    const [validated, setValidated] = useState(false);
    const initialInputState = { 
      FirstName: "",
       MiddleName:"",
       LastName:"",
       Email:"",
       Phone:'',
       Designation:'',
       Batch: '',
       Address:'',
        IsSuccess:false,
        message:'',
        isLoading:false,
        isHideErrorModal:true,
        errMessage:'',
        validationError:null,
        msgList:[],
        Attendee_Count: 1
     
     };
     const [eachEntry, setEachEntry] = useState(initialInputState);
     const {FirstName, LastName, MiddleName,
        Email, Phone, Designation,
        Attendee_Count, Batch, Address,
       
         IsSuccess, message, isLoading, isHideErrorModal, msgList,
         errMessage, validationError, errortitle} = eachEntry;


        // console.log("eachEntry", eachEntry)
         const handleInputChange = e => {
            setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
        };
      
        const handleNumberChange = e => {
           // let num = e.target.value.replace(/\D/g, "");
            let num = e.target.value
            if(!isNaN(num))
            {
              setEachEntry({ ...eachEntry, [e.target.name]: num.length > 0 ? parseInt(num) : null});
            }
          
        };
       
      const handleKeyDown = (e) =>{
        if (e.key === " ") {
          e.preventDefault();
        }
      }
        

        const handleSubmit = async (event) => {
  
            const form = event.currentTarget;
            event.preventDefault();
            event.stopPropagation();
            if (form.checkValidity()) {
                if(parseInt(eachEntry.Attendee_Count) >= 1 && parseInt(eachEntry.Attendee_Count) <= 5)
                {
                    SaveStudent();
                }
                else{
                  setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false, errortitle:"Validation Error occurred!", errMessage: "Maximum 5 attendees are allowed"});
                    window.scrollTo(0, 0);
                }
             
             }
             else{
             
               window.scrollTo(0, 0);
             }
             setValidated(true);
            
            
          };

          const SaveStudent = async () => {
            let response = null;
          
            try {
             // let formData = { ...eachEntry,DOB:dob, PIN: parseInt(eachEntry.PIN), LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks), Amount: parseInt(eachEntry.Amount)}
            let payload = {
              FirstName: FirstName,
              MiddleName: MiddleName,
              LastName: LastName,
              Email: Email,
              Phone: Phone.toString(),
              Designation:Designation,
              Batch: Batch,
              Attendee_Count: Attendee_Count,
              Address: Address
            }
           setEachEntry({ ...eachEntry, isLoading: true});
           response = await axios.post(REGISTER_ALUMNI, payload);
          
           if(response.status === 201)
           {
            let temp = []
            temp.push("You have successfully registered for CTG Alumni Programme")
             setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Success", msgList: temp});
            // handleClear()
          }
          
          else{
            setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Error occurred!", message:"Error Occurred...!"});
          
          }
          
            }
             catch (error) {
             
              if(error.response.data)
              {
                 if(error.response.status === 400)
               {
                  if(error.response.data.Error.ValidationErrors != null)
                  {
                    const validationError =  error.response.data.Error.ValidationErrors
                    setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false, errortitle:"Validation Error occurred!", errMessage: error.response.data.Error.Message, validationError: validationError});
                   // setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true,title:"Error occurred!", message: error.response.data.Error.Message});
                  }
                  else{
                    setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: error.response.data.Error.Message });
                  }
               
               }
               else{
                setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
               }
              }
              else
              setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
          }
          }


          const handleClose = () => {
            window.location.reload();
            window.scrollTo(0, 0);
          }
          const handleCloseErrorModal = () => {
            setEachEntry({ ...eachEntry, isHideErrorModal: true,  msgList: [], errMessage : '',errortitle:'', validationError: null});
          }

          const handleClear = () => {
           setEachEntry(initialInputState)
          }

        
  return (
    <div className="py-4 px-3"  style={{ backgroundColor: "#f5effa", minHeight: "100vh" }}>
    <div className="mx-auto" style={{ maxWidth: "900px" }}>
      
      {/* Header */}
      <div className="text-center mb-4">
        <h4 className="fw-bold" style={{ color: "#800080" }}>
          CTG Alumni
        </h4>
        <p className="text-muted small">
          Please fill in your details carefully
        </p>
      </div>
  
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
  
        <div className="row g-3">
  
          {/* First Name */}
          <div className="col-md-4">
            <Form.Label className="fw-semibold">
              First Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              required
              placeholder="First name"
              name="FirstName"
              value={FirstName}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <Form.Control.Feedback type="invalid">
              Please enter first name.
            </Form.Control.Feedback>
          </div>
  
          {/* Middle Name */}
          <div className="col-md-4">
            <Form.Label className="fw-semibold">Middle Name</Form.Label>
            <Form.Control
              size="sm"
              placeholder="Middle name"
              name="MiddleName"
              value={MiddleName}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
          </div>
  
          {/* Last Name */}
          <div className="col-md-4">
            <Form.Label className="fw-semibold">
              Last Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              required
              placeholder="Last name"
              name="LastName"
              value={LastName}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
             <Form.Control.Feedback type="invalid">
              Please enter last name.
            </Form.Control.Feedback>

          </div>
  
          {/* Designation */}
          <div className="col-md-6">
            <Form.Label className="fw-semibold">Designation</Form.Label>
            <Form.Control
              size="sm"
              placeholder="Your designation"
              name="Designation"
              value={Designation}
              onChange={handleInputChange}
            />
          </div>
  
          {/* Contact */}
          <div className="col-md-6">
            <Form.Label className="fw-semibold">
              Contact Number <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              type="tel"
              required
              maxLength="10"
              placeholder="10 digit mobile number"
              name="Phone"
              value={Phone}
              onChange={handleNumberChange}
            />
             <Form.Control.Feedback type="invalid">
              Please enter contact number.
            </Form.Control.Feedback>
          </div>
  
          {/* Email */}
          <div className="col-md-6">
            <Form.Label className="fw-semibold">Email</Form.Label>
            <Form.Control
              size="sm"
              type="email"
              placeholder="example@email.com"
              name="Email"
              value={Email}
              onChange={handleInputChange}
            />
          </div>
  
          {/* Batch */}
          <div className="col-md-3">
            <Form.Label className="fw-semibold">
              Batch <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              required
              maxLength="4"
              placeholder="YYYY"
              name="Batch"
              value={Batch}
              onChange={handleNumberChange}
            />
             <Form.Control.Feedback type="invalid">
              Please enter Batch.
            </Form.Control.Feedback>
          </div>
  
          {/* Attendee Count */}
          <div className="col-md-3">
            <Form.Label className="fw-semibold">
              Attendees <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              required
              maxLength="1"
              placeholder="No."
              name="Attendee_Count"
              value={Attendee_Count}
              onChange={handleNumberChange}
            />
             <Form.Control.Feedback type="invalid">
              Please enter Number of attendees. Maximum 5 attendees are allowed
            </Form.Control.Feedback>
          </div>
  
          {/* Address */}
          <div className="col-12">
            <Form.Label className="fw-semibold">Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Full address with PIN code"
              name="Address"
              value={Address}
              onChange={handleInputChange}
            />
          </div>
        </div>
  
        {/* Buttons */}
        <div className="d-flex flex-column flex-sm-row gap-3 mt-4 justify-content-end">
          <button
            type="submit"
            className="btn btn-primary px-4"
            style={{ backgroundColor: "#800080" }}
          >
            <span
              className="spinner-border spinner-border-sm me-2"
              hidden={!isLoading}
            />
            Register
          </button>
  
          <button
            type="button"
            className="btn btn-danger px-4"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
  
      </Form>
  
      {/* Notifications */}
      <Notification
        IsSuccess={IsSuccess}
        handleClose={handleClose}
        msgList={msgList}
        title={'Success'}
        isAlumni = {true}
      />
  
      {!isHideErrorModal && (
        <NotifyError
          isHide={isHideErrorModal}
          handleCloseErrorModal={handleCloseErrorModal}
          title={errortitle}
          message={errMessage}
          Errors={validationError}
        />
      )}
  
    </div>
  </div>
  
  )
}

export default OldStudent